import React from "react";
import useDefaultVehicleSnippets from "@/features/getByTransfer/features/snippets/hooks/useDefaultVehicleSnippets";
import VehicleSnippets from "@/features/getByTransfer/features/snippets/components/VehicleSnippets";
import TransfersVehicleType from "../types/TransfersVehicle.type";
import {TransfersDataType} from "../types/TransfersData.type";

interface GetByTransferNoResultsNotificationProps {
    vehicles?: TransfersVehicleType[] | TransfersDataType,
}

function GetByTransferNoResultsNotification(props: GetByTransferNoResultsNotificationProps) {
    const {
        vehicles,
    } = props
    const defaultVehicleSnippets = useDefaultVehicleSnippets();

    return (
        <VehicleSnippets
            vehicles={vehicles as TransfersVehicleType[] || defaultVehicleSnippets}
        />
    )
}

export default GetByTransferNoResultsNotification